//newsletter
function comprueba(){
  if(check.checked){
    document.getElementById("subscribe").disabled = false;
    document.getElementById("mailing-list-email").focus();
  }
  else{
    document.getElementById("subscribe").disabled = true;
  }
}

$(document).ready(function() {
  var check = document.getElementById('check');
  if(document.getElementById("subscribe"))document.getElementById("subscribe").disabled = true;
  if (!check) {
    return;
  } else {
    check.addEventListener("change", comprueba, false);
  }
});

//filtros categorias

$(function() {
  
  if(window.innerWidth > 768) {
  var filters = $('.collection-filter'),
            el,
            elGroup,
            elHandle,
            activeTagInGroup;

        filters.on('click', function(e) {
          el = $(this);
          elGroup = el.data('group');
          elHandle = el.data('handle');
          activeTagInGroup = $('.active-filter[data-group="'+ elGroup +'"]');
          // If the tag clicked is not already active and its group contains an active tag, we will swap tag within the group.
          if ( !el.hasClass('active-filter')  && activeTagInGroup.size() ) {
            e.preventDefault();
            location.href = location.href
            // swap tag
            .replace(activeTagInGroup.data('handle'), elHandle)
            // go back to page 1
            .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
          }
        });
  }
        
      });
     
      // BB_CODIGO
      $(document).ready(function() {  

        if(window.innerWidth > 768) {
        
        var bbStyle = document.createElement('style');

        bbStyle.setAttribute('type', 'text/css');

        bbStyle.innerHTML = ".bb-closed {margin-bottom:0;overflow: hidden;}.trigger {margin-bottom:10px; margin-left:20px; border: none;width: 80px; background-color: #e8e8e8; color: #000}.trigger:hover {background-color: #9c9c9c; color:#fff}.trigger-content {content: -}";

        document.head.appendChild(bbStyle);

        var categorias = $('.advanced-filters');

        var totalItemsToShow = 5;

        function getHeight (el) {
          var totalHeight = 0;
          var elMarginBottom = el.css('margin-bottom');

          el.each( function (i) {
            if(i < totalItemsToShow) {
              totalHeight = totalHeight + $(this).height() + parseFloat(elMarginBottom);
            }
          })
          return totalHeight;
        }

        categorias.each(function (index) {
          var $this = $(this);

          if ($this.children().length > totalItemsToShow) {
            var $parentEl = $this.parent();
            var itemsHeight = getHeight($this.children('.advanced-filter'));

            $this.addClass( "bb-closed" );

            $parentEl.append("<button class='trigger'>+</button>");

            $this.css('height', itemsHeight + 'px');
          }
        })

        $('#toggleFilters').click(function(e) {

          var filter = $('#collectionFilters');


          if(filter.css('display') == 'none') {
            setTimeout(function() {
              categorias.each(function (index) {
                var $this = $(this);

                if ($this.children().length > totalItemsToShow) {
                  var $parentEl = $this.parent();
                  var itemsHeight = getHeight($this.children('.advanced-filter'));

                  $this.addClass( "bb-closed" );

                  $this.css('height', itemsHeight + 'px');
                }
              })
            }, 100);	
          } else {
            $('.trigger').each(function () {
              $(this).text('+');
            })
          }

        })


        $('.trigger').click(function(e) {
          var iParent = $(this).parent().find('.advanced-filters');
          var iChield = iParent.children('.advanced-filter')
          var iButton = $(this).parent().find('.trigger');
          var iHeight = getHeight(iChield);

          
          if ( iParent.height() == iHeight) {
            iParent.css('height', 'auto');
            iButton.text('-');
          } else {
            iParent.css('height', iHeight + 'px');
            iButton.text('+');
          }
        })
        
        //ordenación Jquery

        elementos = $('ul.advanced-filters');
        elementos.each(function(){
          // Ordenar numéricamente los filtros
          $(this).children('li').sort( numerically_ignore_letters ).prependTo($(this));
        });
       } 
      });
      
      numerically_ignore_letters = function(a,b){
        var non_digits = '^(\d)*';
        var a_val = parseInt( $('a', a).text().replace( non_digits, '' ), 10 );
        var b_val = parseInt( $('a', b).text().replace( non_digits, '' ), 10 );

        return  a_val - b_val;
      }

